import React, { useEffect, useState } from "react";
import CookiePopup from "../Cookiepopup";
import { Link } from "react-router-dom";

const Footer = () => {

   const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer>

      <a  id="go-to-top" className={`go-to-top ${show ? "show" : ""}`} href="#navlogo" title="Go to top">
        <i className="bi bi-arrow-up"></i>
      </a>

      <CookiePopup />

      <div className=" py-3 text-sm">
        <div className="container">
  
        <div className="filter-section"></div>

        <div className="row justify-content-between align-items-start mb-4">
          {/* Brand Section */}
          <div className="col-md-6 col-sm-12 mb-4">
            <div className="mb-3">
               <img
                src="/assets/img/logo-icon.png"
                alt="Attendiau."
                className="footer-logo"
              />
            </div>
            <p className=" small">
               © {new Date().getFullYear()} Attendiau. All rights reserved.
            </p>
          </div>

          {/* Categories */}
          <div className="col-md-6 col-sm-12"> 
            <div className="row"> 
              <div className="col-6  mb-4">
                <h6 className="fw-bold mb-3">Categories</h6>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <Link to="/Automotive" className="text-decoration-none small">
                      Automotive
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/Sports" className="text-decoration-none small">
                      Sports
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/Music" className="text-decoration-none small">
                      Music
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-6 mb-4">
                <h6 className="fw-bold mb-3">Sitewide</h6>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <Link to="/Support" className="text-decoration-none small">
                      Support
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/News" className="text-decoration-none small">
                      News
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/Groups" className="text-decoration-none small">
                      Groups
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
